export enum MessageTypes {
    CAMERA_SEND = 'cameraSend',
    CAMERA_UPDATE = 'cameraUpdate',
    CAMERA_SET_VIEWPOINT = 'cameraSetViewpoint',
}
